export default __webpack_public_path__ + "static/sankey-a89b61d32798a3cd23bef992f8b517b9.png";